import gql from 'graphql-tag';

export const ADDRESS_FRAGMENT = gql`
  fragment Address on Address {
    id
    createdAt
    updatedAt
    fullName
    company
    streetLine1
    streetLine2
    city
    province
    postalCode
    country {
      id
      code
      name
    }
    phoneNumber
    defaultShippingAddress
    defaultBillingAddress
    customFields {
      district
    }
  }
`;
